// @flow
import type {Element} from 'react'
import React from 'react'
import {useFragment, graphql} from 'react-relay'

import AppLink from 'components/ui/AppLink'
import styles from './index.scss'
import type {
  UserSection_organization$key as OrganizationKey,
} from './__generated__/UserSection_organization.graphql'
import type {
  UserSection_viewer$key as ViewerKey,
} from './__generated__/UserSection_viewer.graphql'

type Props = $ReadOnly<{
  organization: OrganizationKey,
  viewer: ViewerKey,
}>

const viewerFragment = graphql`
  fragment UserSection_viewer on Person {
    name
    resourcePath
  }
`

const organizationFragment = graphql`
  fragment UserSection_organization on Organization {
    name
    viewerIsMember
    resourcePath
  }
`

function UserSection({
  viewer: viewerKey,
  organization: organizationKey,
}: Props): Element<"div"> {
  const viewer = useFragment(viewerFragment, viewerKey)
  const organization = useFragment(organizationFragment, organizationKey)
  const viewerIsMember = organization.viewerIsMember

  return (
    <div className={styles.container}>
      <div>
        <AppLink
          className={styles.orgName}
          id="orgName"
          href={organization.resourcePath}
        >
          {organization.name}
        </AppLink>
      </div>
      <AppLink
        className={styles.orgNameSubtitle}
        id="profileLink"
        href={viewer.resourcePath}
        target="_blank"
        disabled={!viewerIsMember}
      >
        {viewer.name}
      </AppLink>
    </div>
  )
}

export default UserSection
